/**
 * Packaging OS — Status pill.
 *
 * 4 tones tied to status colors in tokens.css. Pairs color with a dot
 * marker so meaning is not color-only (a11y requirement).
 */

export type StatusTone = "ok" | "warn" | "err" | "info";

interface StatusPillProps {
  tone: StatusTone;
  label: string;
}

export function StatusPill({ tone, label }: StatusPillProps): JSX.Element {
  return (
    <span
      className={`po-status-pill po-status-pill--${tone}`}
      role="status"
      aria-label={label}
    >
      <span aria-hidden="true" className="po-status-pill__dot" />
      <span>{label}</span>
    </span>
  );
}
